import { render, staticRenderFns } from "./deliver.vue?vue&type=template&id=3ed504d6&scoped=true&"
import script from "./deliver.vue?vue&type=script&lang=js&"
export * from "./deliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed504d6",
  null
  
)

export default component.exports